<template>
  <el-dialog
    ref="AddTodo"
    :class="b('')"
    :title="dialogTitle"
    :visible="show"
    :close-on-click-modal="false"
    :before-close="close"
    append-to-body
    :destroy-on-close="true"
    width="700px"
    size="big"
    @open="open"
    @opened="onOpened"
    @closed="onClosed"
  >
    <div
      slot="title"
    >
      <div :class="b('add-todo-title')">
        <span :class="b('title')">{{ dialogTitle }}</span>
        <span :class="b('button-container')">
          <div
            :class="[b('todo-transform'), 'btn']"
          >
            <el-popover
              ref="popover"
              v-model="showTodoTransformPopover"
              :popper-class="b('popover')"
              placement="bottom"
              width="368"
              trigger="manual"
            >
              <div
                v-clickoutside="() => showTodoTransformPopover = false"
                :class="b('poppover-container')"
              >
                <div :class="b('poppover-header')">
                  <span :class="b('poppover-header-title')">
                    {{ $t('home.todo.todoToIssueTitle') }}
                  </span>
                </div>
                <div :class="b('poppover-main')">
                  <el-cascader-panel
                    v-model="selectProjectIdAndIssue"
                    :options="projectOptions"
                    :props="props"
                  >
                    <template slot-scope="{ data }">
                      <div
                        v-overflow-tooltip="{
                          content: data.label,
                          placement: 'left'
                        }"
                        class="text-ellipsis"
                      >
                        {{ data.label }}
                      </div>
                    </template>
                  </el-cascader-panel>
                </div>
                <div :class="b('poppover-footer')">
                  <el-button
                    size="mini"
                    @click="showTodoTransformPopover = false"
                  >
                    {{ $t('button.cancel') }}
                  </el-button>
                  <el-button
                    size="mini"
                    type="primary"
                    @click="handleTodoTransformIssue"
                  >
                    {{ $t('button.save') }}
                  </el-button>
                </div>
              </div>
              <span
                v-show="id"
                slot="reference"
                :class="b('todo-transform-text', showTodoTransformPopover ? 'is-visible' : '')"
                @click="onTransformPopover"
              >
                <el-tooltip
                  :content="$t('home.todo.todoToIssue')"
                  placement="top"
                >
                  <em class="zkicon iconzhuanhuan" />
                </el-tooltip>
              </span>
            </el-popover>
          </div>
          <span
            v-if="id"
            class="btn"
            @click="deleteTodo"
          >
            <em class="zkicon icondelete" />
          </span>
        </span>
      </div>
    </div>
    <div
      v-loading="loading"
      :class="b('todo-container')"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-position="top"
      >
        <el-form-item
          :label="$t('home.todo.title')"
          prop="name"
        >
          <el-input
            ref="addTodoFocus"
            v-model="form.name"
            :maxlength="$inputLimit.issueSummary"
            show-word-limit
            type="textarea"
            :class="b('textarea')"
            :rows="1"
            :autosize="{minRows: 1,maxRows: 2}"
            :placeholder="$t('home.todo.addTodoTitle')"
            @keypress.enter.native.prevent
          >
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="$t('home.todo.status')"
                prop="status"
              >
                <el-select
                  v-model="form.status"
                  :placeholder="$t('home.todo.select')"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in stateOptions"
                    :key="item.categoryId"
                    :label="item.categoryName"
                    :value="item.categoryId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$t('home.todo.priority')"
                prop="priority"
              >
                <el-select
                  v-model="form.priority"
                  :placeholder="$t('home.todo.select')"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in priorityOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item
          :label="$t('home.todo.dueDate')"
          prop="dueDate"
        >
          <DateTimePicker
            v-model="form.dueDate"
            style="width: 50%;"
            type="datetime"
            default-time="18:00:00"
            prefix-icon="el-icon-time"
            :placeholder="$t('home.todo.select')"
          >
          </DateTimePicker>
        </el-form-item>

        <el-form-item
          :label="$t('home.todo.description')"
        >
          <RichEditor
            :key="editorKey"
            :class="b('markdown')"
            placeholder=""
            :value="form.description"
            :options="{}"
            :upload-options="{
              fileEntity: 'markdown',
              fileModule: 'issue',
              linkId: 0
            }"
            @change="handleMarkdownChange"
          >
          </RichEditor>
        </el-form-item>

        <el-form-item
          :label="$t('home.todo.attachment')"
        >
          <Upload
            v-if="show"
            ref="uploadFiles"
            :todo-list-id="id"
            :file-list.sync="attachment"
          />
        </el-form-item>
      </el-form>
    </div>

    <div
      slot="footer"
      :class="b('footer')"
    >
      <div>
        <el-button
          @click="close"
        >
          {{ $t('button.cancel') }}
        </el-button>
        <el-button
          :loading="addTodoLoading.loading"
          :disabled="isPreviewMode"
          type="primary"
          @click="addTodoLoading.fn"
        >
          {{ dialogBtn }}
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import theme from '@zk/theme/lib/variables.scss';
import { createLoadingEvent } from '@zk/framework-vue';
import Upload from '@/components/GridDashboard/components/Upload';
import RichEditor from 'common-module/src/components/Editor/RichEditor';
import { DateTimePicker } from 'zk-date-picker';

import {
  getTodoPriorityList,
  getListStateCategory,
  addTodo,
  deleteTodo,
  getTodoDetail,
  updateTodo,
  todoListConvertIssue,
  getIssueTypeList,
  getTodoProjectList,
  getIssueSelectOptions
} from '@/api/home';
import { debounce } from 'lodash';

export default {
  name: 'AddTodoDialog',
  components: {
    Upload,
    RichEditor,
    DateTimePicker
  },
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    show: {
      type: Boolean,
      default: false
    },
    defaultTodo: {
      type: Object,
      default: () => {}
    },
    isPreviewMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      bemNS: theme.bemNS,
      addTodoLoading: createLoadingEvent(this.save),
      editorKey: 0,
      form: {
        name: '',
        status: 2,
        priority: '',
        dueDate: null,
        description: ''
      },
      attachment: [],
      priorityOptions: [],
      stateOptions: [],
      detail: null,
      selectProjectIdAndIssue: [],
      projectOptions: [],
      showPopover: false,
      showTodoTransformPopover: false,
      props: {
        lazy: true,
        lazyLoad: async function(node, resolve) {
          if (!node.value) {
            resolve([]);
            return;
          }
          const res = await getIssueTypeList(node.value);
          resolve(res.map(item => ({
            value: item.id,
            label: item.name,
            leaf: true
          })));
        }
      },
      loading: false
    };
  },
  computed: {
    dialogTitle() {
      return this.id ? this.$t('home.todo.editTodo') : this.$t('home.todo.addTodo');
    },
    dialogBtn() {
      return this.id ? this.$t('button.save') : this.$t('button.addTo');
    },
    rules() {
      return {
        name: [
          { required: true, message: this.$t('home.todo.input'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('home.todo.select'), trigger: 'change' }
        ]
      };
    }
  },
  methods: {
    addTodoFocus() {
      if (this.id) {
        return;
      }
      this.$refs.addTodoFocus?.focus();
    },
    async open() {
      try {
        this.loading = true;
        this.$nextTick(()=> this.addTodoFocus());
        if (this.defaultTodo) {
          this.form = this.defaultTodo;
        }
        [this.priorityOptions, this.stateOptions] = await Promise.all([getTodoPriorityList(), getListStateCategory()]);
        if (this.id) {
          const res = await getTodoDetail({ id: this.id });
          const { name, status, priority, dueDate, fileOuterVOList, description } = res;
          this.form = {
            name,
            status,
            priority,
            dueDate,
            description: description || ''
          };
          this.editorKey++;
          // 上传转换
          this.detail = res;
          const project = await getTodoProjectList();
          this.projectOptions = project.list?.map(item => ({
            value: item.value,
            label: item.name,
            children: []
          })).filter(item => item.value !== 0);
          this.formatAttachment(fileOuterVOList);
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    onClosed() {
      this.attachment = [];
    },
    save() {
      this.$refs.form.validate(async r => {
        if (!r) {
          return;
        }
        const p = {
          ...this.form,
          attachment: this.attachment?.map(item => item.id)
        };

        if (this.id) {
          p.id = this.id;
          await updateTodo(p);
        } else {
          await addTodo(p);
          this.$track.send('TodoList_AddTodo', {}, true);
        }
        this.$emit('submit');
        this.$refs.form.resetFields();
      });
    },
    deleteTodo() {
      if (!this.id) {
        return;
      }
      this.$confirm(this.$t('home.todo.confirmTips'), this.$t('home.todo.confirmTitle'), {
        confirmButtonText: this.$t('button.confirm'),
        cancelButtonText: this.$t('button.cancel')
      }).then(async () => {
        await deleteTodo({ id: this.id });
        this.$message({
          type: 'success',
          message: this.$t('home.todo.deleteTips')
        });
        this.$refs.form.resetFields();
        this.$emit('submit');
      });
    },
    cancel() {
      this.$refs.form.resetFields();
      this.showPopover = false;
      this.selectProjectIdAndIssue = [];
      this.$emit('cancel');
    },
    close() {
      this.$refs.form.resetFields();
      this.showPopover = false;
      this.selectProjectIdAndIssue = [];
      this.$emit('close');
    },
    handleTodoTransformIssue: debounce(async function () {
      if (!this.form.name) {
        this.$refs.form.validate();
        return;
      }
      const { id } = this.detail;
      if (this.selectProjectIdAndIssue.length < 2) {
        this.$message.warning(this.$t('home.todo.todoToIssueTitle'));
        return;
      }
      const projectId = this.selectProjectIdAndIssue[0];
      const issueTypeId = this.selectProjectIdAndIssue[1];
      const res = await getIssueSelectOptions(issueTypeId, projectId);
      const statusField = res.find(item => item.fieldCode === 'status');
      const attachmentId = this.attachment.map(i => i.id);
      const status = statusField.optionVOList.find(i => i.extendValue === this.form.status)?.value || statusField?.optionVOList[0].value;
      await todoListConvertIssue({ id, issueTypeId, projectId, status, priority: this.form.priority, description: this.form.description, dueDate:this.form.dueDate, attachment: attachmentId });
      this.$message.success(this.$t('home.todo.todoToIssueSuccess'));
      this.selectProjectIdAndIssue = [];
      this.showTodoTransformPopover = false;
      this.$emit('submit');
      this.$track.send('TodoList_DoneSwitchToProject', {}, true);
    }, 300),
    /* 附件列表数据处理 */
    formatAttachment(data) {
      const res = data.map(i => ({
        id: i.fileKey,
        name: `${i.fileName}${i.fileSuffix}`,
        type: i.fileType,
        url: i.originalUrl || i.fileDownloadPath, // originalUrl
        time: this.$options.filters.formatDateTimeSecond(i.uploadTime),
        size: i.fileSize,
        ...i
      }));
      this.attachment = res;
    },
    onTransformPopover() {
      this.showTodoTransformPopover = true;
      this.$track.send('TodoList_SwitchToProject', {}, true);
    },
    onOpened() {
      const el = document.querySelector('.zk-add-todo-dialog .el-form-item__label');
      el.scrollIntoView(true);
    },
    handleMarkdownChange(val) {
      this.form.description = val;
    }
  }
};
</script>

<style lang="scss" scoped>
@include b(add-todo-dialog) {
  ::v-deep {
    .el-dialog {
      min-width: 560px;
    }
  }
  @include e(add-todo-title) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-right: 40px;
    @include e(title) {
      font-size: 18px;
      font-weight: var(--weight-font-Blod);
      color: #000000;
    }
  }
  @include e(form-item-date) {
    display: inline-flex;
  }
  @include e(form-item-upload) {
    display: inline-block;
  }
  @include e(todo-transform) {}
  @include e(todo-transform-text) {
    display: inline-block;
    color: var(--primary-color);
    font-weight: var(--weight-font-Semiblod);
    font-size: var(--size-font-7);
    cursor: pointer;
    border-radius: var(--radius-mini);
    @include m(is-visible) {
      background: #DBE6FF !important;
      .zkicon {
        color: #709dff;
        font-weight: var(--weight-font-icon);
      }
    }
  }
  @include e(todo-container) {
    // overflow-x: hidden;
    ::v-deep {
      .vditor.vditor--fullscreen {
        .vditor-toolbar--pin {
          position: relative;
        }
      }
    }
  }
  @include e(action) {}
  @include e(action-cancel) {}
  @include e(action-save) {}

  @include e(markdown){
    line-height: 1.2;
    @include m(vditor) {
      ::v-deep {
        .vditor-toolbar{
          padding-left: 10px !important;
        }
      }
    }
  }
  @include e(button-container) {
    display: flex;
    align-items: center;
    .btn + .btn {
      margin-left: var(--m-medium);
    }
    .zkicon {
      cursor: pointer;
      font-size: var(--size-font-5);
    }
    .btn {
      &:hover {
        background: #f6f9ff;
        .zkicon {
          color: #709dff;
        }
      }
    }
  }

  ::v-deep {
    .el-dialog__body {
      // padding: 10px 20px 20px 50px;
    }
    .el-textarea .el-textarea__inner {
      padding-bottom: 40px;
    }
    .el-form-item__label {
      padding: 0 4px 0 0;
    }
    .el-form-item {
      margin-bottom: var(--p-default);
    }
  }
}
</style>
<style lang="scss">
  .zk-add-todo-dialog__popover {
    padding: 0;
    .popper__arrow::after {
      border-bottom-color: #F0F0F0 !important;
    }
    .el-cascader-node {
      min-width: auto;
    }
  }
  .zk-add-todo-dialog__poppover-header {
    background: #F0F0F0;
    padding: 12px 16px;
    .zk-add-todo-dialog__poppover-header-title {
      display: block;
      font-size: var(--size-font-7);
      color: var(--font-color-1);
      line-height: 20px;
      margin-bottom: 4px;
    }
  }
  .zk-add-todo-dialog__poppover-footer {
    text-align: right;
    padding: 10px 15px;
    border-top: 1px solid #E6E6E6;
  }
  .zk-add-todo-dialog__poppover-main {
    .el-cascader-menu {
      max-width: 50%;
    }
    .is-bordered {
      border: 0;
    }
  }
</style>
